import { Text } from '@mnd-frontend/ui/publish/components';

const SelectingTopicsAndRegions = () => (
  <>
    <Text as="h3" variant="headlineSmall">
      Selecting topics and regions
    </Text>
    <Text as="p" variant="body">
      Topics and regions are predefined categories that you can use to reach Mynewsdesk subscribers.
      Whenever you post content on a certain topic, it is sent via email to every subscriber of that
      topic.
    </Text>
    <Text as="h4" variant="labelMedium" marginTop="SPACING_3">
      Be specific
    </Text>
    <Text as="p" variant="body">
      Always use topics and regions that are relevant for your story. Narrowing down your story with
      a subtopic does not result in limited reach - quite the opposite! By using a subtopic, you
      will reach subscribers of both the main topic and the subtopic.
    </Text>
    <Text as="p" variant="body" color="GREY_800" marginTop="SPACING_2">
      EXAMPLE 1:
    </Text>
    <Text as="p" variant="body">
      If you use the topic <i>“Politics”</i> and the region <i>“Copenhagen”</i> you will reach
    </Text>
    <ul>
      <li>People subscribing to Politics</li>
      <li>People subscribing to Copenhagen</li>
      <li>People subscribing to Politics in Copenhagen</li>
    </ul>
    <Text as="p" variant="body" color="GREY_800">
      EXAMPLE 2:
    </Text>
    <Text as="p" variant="body">
      If you use the subtopic <i>“Elections (Politics)”</i> you will reach
    </Text>
    <ul>
      <li>People subscribing to Elections</li>
      <li>People subscribing to Politics</li>
    </ul>
  </>
);

export default SelectingTopicsAndRegions;
